module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO51Activos.cca7fc4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO51Activos.mp4
// module id = 777
// module chunks = 1